<div class="card">
  <canvas #nextShapeCanvas width="120" height="120"></canvas>
</div>